const TEXTS = {
  NO_SEARCH_RESULTS: 'No search results',
};

const KEY = 'LF_LABEL::';

const createLabelWithoutValue = (value: string) => `${KEY}${value}`;

export { TEXTS, createLabelWithoutValue, KEY };
